import React from "react"
import { ISearchValue, SearchTypeEnum } from "../../../../components2/YhPageHeader/Types";
import { YhPageHeader } from "../../../../components2/YhPageHeader";
import { useDataBranchModel } from "../dataBranchModel"
import useMdmModel from "../../../../model/mdmModel"

export function SearchForm() {
    const {
        searchParam,
        selectData,
        upDataSearchParam,
        resetSearchParam,
        loadData
    } = useDataBranchModel();
    const {mdmCatalog,mdmBranch} = useMdmModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "分支编码",
            fieldName: "code",
            size: "small",
            disabled: false,
            options: mdmBranch
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "数据目录编码",
            fieldName: "catalog",
            size: "small",
            disabled: false,
            options: mdmCatalog
        },
    
    ]
    return (
        <YhPageHeader
            title="分支列表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={upDataSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    )
}